
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.897 3.603a2.4 2.4 0 00-3.394 0L8.4 12.706V16.1h3.394l9.103-9.103a2.4 2.4 0 000-3.394z","fill":"#1BA7E1"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.4 7.7a2.4 2.4 0 012.4-2.4h4.8a1.2 1.2 0 010 2.4H4.8v12h12v-4.8a1.2 1.2 0 112.4 0v4.8a2.4 2.4 0 01-2.4 2.4h-12a2.4 2.4 0 01-2.4-2.4v-12z","fill":"#1BA7E1"}})])
          )
        }
      }
    